import {
  Button, IconButton, InputBase, Paper,
} from '@material-ui/core'
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material'
import { PropTypes } from 'prop-types'
import React from 'react'
import style from './index.module.css'

const Search = ({
  onSearchChange, value, onSearchHandler, placeholder, clearSearch,
}) => (
  <Paper className={ `container-fluid ${ style.outerDiv }` }>
    <div className='d-flex'>
      <IconButton sx={ { p: '10px' } } aria-label='menu'>
        <SearchIcon />
      </IconButton>
      <InputBase
        value={ value }
        sx={ { ml: 1, flex: 1 } }
        placeholder={ placeholder }
        onChange={ onSearchChange }
      />
    </div>
    <div className='d-flex'>
      <IconButton sx={ { p: '10px' } } aria-label='menu' onClick={ clearSearch }>
        <ClearIcon />
      </IconButton>
      <Button
        onClick={ onSearchHandler }
        disabled={ value?.length < 2 }
        className={ style.searchButton }
      >
        Search
      </Button>
    </div>
  </Paper>
)

Search.defaultProps = {
  placeholder: 'Search',
}

Search.propTypes = {
  onSearchChange: PropTypes.func.isRequired,
  onSearchHandler: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  clearSearch: PropTypes.func.isRequired,
}
export default Search
